import { PendingPaymentDto } from '../../../models/dtos/pending-payment.dto';

export const mockPendingPayment: PendingPaymentDto = {
  row_id: 101,
  description: 'Late fee',
  billing_type: 2,
  input_date: '2025-07-01T00:00:00Z',
  start_date: '2025-07-01T00:00:00Z',
  expire_date: '2025-07-10T00:00:00Z',
  billing_next_date: '2025-07-15T00:00:00Z',
  amount_fixed: 50.00,
  loan_number: 'LN-12345',
};
